import { useUserGeneralProfile } from "@jugl-web/domain-resources/users/hooks/useUserGeneralProfile";
import { UserRole } from "@jugl-web/rest-api";
import useEntity from "@web-src/modules/entities/hooks/useEntity";
import { selectAuthDataState } from "@web-src/modules/auth/store/authSlice";
import { useSelector } from "react-redux";

export const useMe = () => {
  const { entity } = useEntity();
  const authData = useSelector(selectAuthDataState);
  const meJid = authData?.data?.jid;
  const { profile, isLoading } = useUserGeneralProfile({
    // TODO: make sure we don't use it outside entity context
    // oxlint-disable-next-line typescript/ban-ts-comment
    // @ts-ignore
    entityId: entity?.id,
    userId: meJid,
  });

  const isAdmin = profile?.role === UserRole.admin;

  return {
    id: meJid,
    me: profile?._user,
    isLoading,
    profile,
    isAdmin,
  };
};

export const useLoadedMe = () => {
  const { me, id, isAdmin } = useMe();

  if (!me || !id) {
    throw new Error("Me is not loaded yet");
  }
  return { me, meId: id, isAdmin };
};
